export default "__VITE_ASSET__gueX1xNJ__"